import React from 'react'
import { isEmpty } from 'lodash'

import { Pill } from '@/components/pills/Pill'

const TOOLS_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M4.08333 5.83333H5.83333V4.08333L3.79166 2.04166C4.44478 1.72974 5.17854 1.62797 5.8919 1.75036C6.60525 1.87275 7.26312 2.21329 7.77491 2.72508C8.2867 3.23687 8.62724 3.89474 8.74963 4.6081C8.87203 5.32145 8.77025 6.05521 8.45833 6.70833L11.9583 10.2083C12.1904 10.4404 12.3208 10.7551 12.3208 11.0833C12.3208 11.4115 12.1904 11.7263 11.9583 11.9583C11.7263 12.1904 11.4115 12.3208 11.0833 12.3208C10.7551 12.3208 10.4404 12.1904 10.2083 11.9583L6.70833 8.45833C6.05521 8.77025 5.32145 8.87203 4.6081 8.74963C3.89474 8.62724 3.23687 8.2867 2.72508 7.77491C2.21329 7.26312 1.87275 6.60525 1.75036 5.8919C1.62797 5.17854 1.72974 4.44478 2.04166 3.79166L4.08333 5.83333Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const VARIABLES_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M4.08333 2.33334C3.77391 2.33334 3.47717 2.45626 3.25838 2.67505C3.03958 2.89384 2.91667 3.19059 2.91667 3.50001V5.25001C2.91667 5.71414 2.79375 6.15926 2.57496 6.48745C2.35617 6.81564 2.05942 7.00001 1.75 7.00001C2.05942 7.00001 2.35617 7.18438 2.57496 7.51257C2.79375 7.84076 2.91667 8.28588 2.91667 8.75001V10.5C2.91667 10.8094 3.03958 11.1062 3.25838 11.325C3.47717 11.5438 3.77391 11.6667 4.08333 11.6667"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91667 2.33334C10.2261 2.33334 10.5228 2.45626 10.7416 2.67505C10.9604 2.89384 11.0833 3.19059 11.0833 3.50001V5.25001C11.0833 5.71414 11.2063 6.15926 11.425 6.48745C11.6438 6.81564 11.9406 7.00001 12.25 7.00001C11.9406 7.00001 11.6438 7.18438 11.425 7.51257C11.2063 7.84076 11.0833 8.28588 11.0833 8.75001V10.5C11.0833 10.8094 10.9604 11.1062 10.7416 11.325C10.5228 11.5438 10.2261 11.6667 9.91667 11.6667"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const HANDOFF_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path
      d="M11.6667 5.83334H2.33334L5.54167 2.33334"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33334 8.16666H11.6667L8.45834 11.6667"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const MODEL_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <g
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="4.66667" cy="11.0833" r="1.16667" />
      <circle cx="9.33333" cy="2.91667" r="1.16667" />
      <circle cx="4.66667" cy="2.91667" r="1.16667" />
      <circle cx="2.33333" cy="7" r="1.16667" />
      <circle cx="9.33333" cy="11.0833" r="1.16667" />
      <circle cx="7" cy="7" r="1.16667" />
      <circle cx="11.6667" cy="7" r="1.16667" />
      <path d="M3.5 7H5.83333" />
      <path d="M8.16666 7H10.5" />
      <path d="M8.75 4.08334L7.58334 5.83334" />
      <path d="M5.25 4.08334L6.41667 5.83334" />
      <path d="M6.41667 8.16666L5.25 9.91666" />
      <path d="M7.58334 8.16666L8.75 9.91666" />
    </g>
  </svg>
)

const TEMPERATURE_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <g
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M11.0833 2.91667C11.2366 3.06986 11.3581 3.25174 11.4411 3.45192C11.524 3.6521 11.5667 3.86666 11.5667 4.08334C11.5667 4.30002 11.524 4.51457 11.4411 4.71475C11.3581 4.91493 11.2366 5.09681 11.0833 5.25L6.41667 9.91667H4.08333V7.58334L8.75 2.91667C8.90319 2.76343 9.08507 2.64187 9.28525 2.55894C9.48543 2.47601 9.69999 2.43332 9.91667 2.43332C10.1333 2.43332 10.3479 2.47601 10.5481 2.55894C10.7483 2.64187 10.9301 2.76343 11.0833 2.91667Z" />
      <path d="M9.33333 4.08334L8.45833 3.20834" />
      <path d="M7.58333 5.83334L6.70833 4.95834" />
      <path d="M5.83333 7.58334L4.95833 6.70834" />
      <path d="M4.08333 9.91666L2.33333 11.6667" />
    </g>
  </svg>
)

// Node types that have a drawer with tabs — these are the only types that
// render the chip row. Decision, tool, exit, entry have custom drawer views
// without tabs, so chips would be dead ends there.
export const TABBED_NODE_TYPES = new Set(['greeting', 'prompt', 'subagent'])

// "1 tool" / "3 tools" — regular +s plural for the count labels.
const pluralize = (count, singular) => `${count} ${count === 1 ? singular : `${singular}s`}`

// Sub-agent-only chips: handoffs, model, temperature, reasoning effort. Split
// out of buildChips to keep each function's cognitive complexity in check.
const buildSubagentChips = (node, config) => {
  const chips = []
  const handoffsCount = Array.isArray(node.peerHandoffs) ? node.peerHandoffs.length : 0
  if (handoffsCount > 0) {
    chips.push({
      key: 'handoffs',
      tabKey: 'handoffs',
      icon: HANDOFF_ICON,
      label: pluralize(handoffsCount, 'handoff'),
    })
  }
  if (config.model) {
    chips.push({ key: 'model', tabKey: 'model', icon: MODEL_ICON, label: config.model })
  }
  if (config.temperature !== undefined && config.temperature !== null) {
    chips.push({
      key: 'temperature',
      tabKey: 'model',
      icon: TEMPERATURE_ICON,
      label: `Temp: ${config.temperature}`,
    })
  }
  // Reasoning effort — no icon, matching the design mock's text-only Reasoning
  // pill. Opens the LLM config tab (same as model / temp) since ModelTab shows it.
  if (config.reasoningEffort) {
    chips.push({
      key: 'reasoning',
      tabKey: 'model',
      icon: null,
      label: `Reasoning: ${config.reasoningEffort}`,
    })
  }
  return chips
}

// Build the chip list for a node. Each chip has a label, an icon, and the
// drawer tab key it opens. Returns [] when none of the categories carry data.
// Exported so consumers (canvas card + drawer hero) can render the exact
// same set without re-implementing the rules.
export const buildChips = (node) => {
  if (!node || !TABBED_NODE_TYPES.has(node.type)) {
    return []
  }
  const config = node.config || {}
  const chips = []
  const toolsCount = Array.isArray(config.tools) ? config.tools.length : 0
  if (toolsCount > 0) {
    chips.push({
      key: 'tools',
      tabKey: 'tools',
      icon: TOOLS_ICON,
      label: pluralize(toolsCount, 'tool'),
    })
  }
  const variablesCount = Array.isArray(config.requiredVars) ? config.requiredVars.length : 0
  if (variablesCount > 0) {
    chips.push({
      key: 'variables',
      tabKey: 'variables',
      icon: VARIABLES_ICON,
      label: pluralize(variablesCount, 'variable'),
    })
  }
  if (node.type === 'subagent') {
    chips.push(...buildSubagentChips(node, config))
  }
  return chips
}

// Shared chip row for both the canvas node card and the drawer hero. The
// host passes `onChipClick(nodeId, tabKey)` — clicking a chip stops bubbling
// (so the parent's click/drag handlers don't fire on the canvas card) and
// then hands off the tab key. `dataTestIdPrefix` lets tests distinguish
// canvas chips from drawer chips.
const NodeChips = ({ node, nodeId, onChipClick, dataTestIdPrefix }) => {
  const chips = buildChips(node)
  if (isEmpty(chips)) {
    return null
  }

  const stopPointerDown = (event) => event.stopPropagation()

  const handleClick = (event, tabKey) => {
    event.stopPropagation()
    if (onChipClick) {
      onChipClick(nodeId, tabKey)
    }
  }

  return (
    <div
      className="voice-agents__canvas-node-chips"
      data-testid={`${dataTestIdPrefix}-chips`}
      onPointerDown={stopPointerDown}
    >
      {chips.map((chip) => (
        <Pill
          key={chip.key}
          xs
          clickable
          outlined
          icon={chip.icon}
          onClick={(event) => handleClick(event, chip.tabKey)}
          onPointerDown={stopPointerDown}
          dataTestId={`${dataTestIdPrefix}-chip-${chip.key}`}
        >
          {chip.label}
        </Pill>
      ))}
    </div>
  )
}

export default NodeChips
